import { toast } from 'react-toastify';
import store from '../states';
import {
  asyncUpVoteThread,
  asyncDownVoteThread,
  asyncNeutralVoteThread,
} from '../states/threads/action';
import {
  asyncUpVoteThreadDetail,
  asyncDownVoteThreadDetail,
  asyncNeutralVoteThreadDetail,
  asyncUpVoteComment,
  asyncDownVoteComment,
  asyncNeutralVoteComment,
} from '../states/threadDetail/action';

export function isVoted(voteData, userId) {
  return voteData?.includes(userId);
}

export function toggleLikeThread({ voteData, threadId, userId }) {
  if (userId) {
    isVoted(voteData, userId)
      ? store.dispatch(asyncNeutralVoteThread(threadId))
      : store.dispatch(asyncUpVoteThread(threadId));
  } else {
    toast.error('Please login first to like this thread');
  }
}

export function toggleDislikeThread({ voteData, threadId, userId }) {
  if (userId) {
    isVoted(voteData, userId)
      ? store.dispatch(asyncNeutralVoteThread(threadId))
      : store.dispatch(asyncDownVoteThread(threadId));
  } else {
    toast.error('Please login first to dislike this thread');
  }
}

export function toggleLikeThreadDetail({ voteData, threadId, userId }) {
  if (userId) {
    isVoted(voteData, userId)
      ? store.dispatch(asyncNeutralVoteThreadDetail(threadId))
      : store.dispatch(asyncUpVoteThreadDetail(threadId));
  } else {
    toast.error('Please login first to like this thread');
  }
}

export function toggleDislikeThreadDetail({ voteData, threadId, userId }) {
  if (userId) {
    isVoted(voteData, userId)
      ? store.dispatch(asyncNeutralVoteThreadDetail(threadId))
      : store.dispatch(asyncDownVoteThreadDetail(threadId));
  } else {
    toast.error('Please login first to dislike this thread');
  }
}

export function toggleLikeComment({ voteData, threadId, commentId, userId }) {
  if (userId) {
    isVoted(voteData, userId)
      ? store.dispatch(asyncNeutralVoteComment({ threadId, commentId }))
      : store.dispatch(asyncUpVoteComment({ threadId, commentId }));
  } else {
    toast.error('Please login first to like this comment');
  }
}

export function toggleDislikeComment({
  voteData,
  threadId,
  commentId,
  userId,
}) {
  if (userId) {
    isVoted(voteData, userId)
      ? store.dispatch(asyncNeutralVoteComment({ threadId, commentId }))
      : store.dispatch(asyncDownVoteComment({ threadId, commentId }));
  } else {
    toast.error('Please login first to dislike this comment');
  }
}
